import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { useMediaSize } from '../tools/utils';
const getAlignment = align => {
    switch (align) {
        case 'center':
            return 'center';
        case 'right':
            return 'flex-end';
        default:
            return 'flex-start';
    }
};
const getVerticalAlignment = alignVertical => {
    switch (alignVertical) {
        case 'center':
            return 'center';
        case 'bottom':
            return 'flex-end';
        default:
            return 'flex-start';
    }
};
const getFlexDirection = (reverse, isRowMode) => {
    const rowOrColumn = isRowMode ? 'row' : 'column';
    return `flex-direction: ${reverse ? `${rowOrColumn}-reverse` : rowOrColumn};`;
};
/**
 * Generates the style 'flex-direction: row|column[-reversed]'
 */
const BreakpointInline = styled(Box).attrs((props) => ({
    reverse: props.reverse || false,
    isRowMode: props.isRowMode,
})) `
  display: flex;
  ${({ reverse, isRowMode }) => getFlexDirection(reverse, isRowMode)}
`;
const Inline = ({ children, space, spaceColumn, align, alignVertical, reverse, className, breakpointWidth, }) => {
    const [isRowMode, setRowMode] = useState(false);
    const isSmDown = useMediaSize('SmDown');
    const isMdOnly = useMediaSize('MdOnly');
    const isLgUp = useMediaSize('LgUp');
    useEffect(() => {
        switch (breakpointWidth) {
            case 'sm':
                setRowMode(!isSmDown);
                break;
            case 'md':
                setRowMode(!(isMdOnly || isSmDown));
                break;
            case 'lg':
                setRowMode(isLgUp);
                break;
            default:
                setRowMode(true);
                break;
        }
    }, [isSmDown, isMdOnly, isLgUp, breakpointWidth, isRowMode]);
    const filteredChildren = React.Children.toArray(children).filter(Boolean);
    return (React.createElement(BreakpointInline, Object.assign({ display: "flex", gridRowGap: isRowMode ? space : spaceColumn, gridColumnGap: isRowMode ? space : spaceColumn, isRowMode: isRowMode, reverse: reverse, flexWrap: "wrap", className: className, "data-testid": "mui-inline-container" }, (align && { justifyContent: getAlignment(align) }), (alignVertical && {
        alignItems: getVerticalAlignment(alignVertical),
    })), filteredChildren));
};
export { Inline };
//# sourceMappingURL=Inline.js.map